module.exports = __webpack_public_path__ + "assets/kids/img/extra-feedback.517a7932.png";